import * as React from 'react'
import { ActivityIndicator } from 'antd-mobile'
import * as styles from './style/index.scss'

const PageLoadingC = () => (
    <ActivityIndicator text="数据加载中..." size="large" className={styles.pageLoading}/>
)

export default PageLoadingC
